/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsBRLYtabs = {
    init: function () {
console.dir('init tabs');
      let $tabs = $(".brlytabs li, .brlytabs li a");

      $tabs.on("click", function (el) {
        el.preventDefault();

        // toggle active tab
        $tabs.removeClass("is-active active");
        $(this).addClass("is-active");

        let $tabIndex = $(this).index();
        let $tabContent = $(this)
          .parents(".brlytabs")
          .next(".brlytabs-content");

        // toggle corresponding tab content
        $tabContent.children("li, li a").removeClass("is-active active");
        $tabContent
          .children("li, li a")
          .eq($tabIndex)
          .addClass("is-active")
          .show()
          .css({ display: "block" })
          .siblings()
          .hide()
          .removeClass("is-active");
      });


     //open reviews tab when yotpo review stars are clicked
         let $review_open_tab_link = $(".open-reviews-tab");
            console.dir('.open-reviews-tab');
      console.dir($review_open_tab_link);
      $review_open_tab_link.on("click", function (el) {
        el.preventDefault();
        $("#tab6_link a").trigger("click");

         var is_mobile = true;

    if( $('.mobile-header ').css('display')=='none') {
        is_mobile = false;       
    }

    // now I can use is_mobile to run javascript conditionally

    if (is_mobile == true) {
        //Conditional script here
    }else{
       $('html, body').animate({scrollTop: $('#tab6_link > a').offset().top -100 }, 'fast');
    }

       
      });
      // end open reviews tab
      
    },
    unload: function () {
      $(".brlytabs li, .brlytabs li a").off();
    },
  };
  /******/
})();
